"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogContentText = _interopRequireDefault(require("@material-ui/core/DialogContentText"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _index = require("../../config/index");
var _Translations = require("react-platform-components/dist/Translations");
var _core = require("@material-ui/core");
var _reactRedux = require("react-redux");
var _ChatActions = require("../ChatActions");
var _formik = require("formik");
var _formValidators = require("react-platform-components/dist/form-validators");
var _formFields = require("react-platform-components/dist/form-fields");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    buttonsHeaderWrapper: {
      display: "flex",
      gap: "10px",
      justifyItems: "center",
      justifyContent: "center",
      alignItems: "center"
    },
    offerButton: {
      color: "black",
      cursor: "pointer"
    }
  };
});
var MakePropositionDialog = function MakePropositionDialog(_ref) {
  var user = _ref.user,
    product = _ref.product;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    inProgress = _useState2[0],
    setInProgress = _useState2[1];
  var dispatch = (0, _reactRedux.useDispatch)();
  var classes = useStyles();
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    offerPopUpOpen = _useState4[0],
    setOfferPopUpOpen = _useState4[1];
  var _useSelector = (0, _reactRedux.useSelector)(function (_ref2) {
      var chatReducer = _ref2.chatReducer;
      return {
        chat: chatReducer.chat
      };
    }),
    chat = _useSelector.chat;
  var lastMessage = chat !== null ? chat[chat.length - 1] : null;
  var formik = (0, _formik.useFormik)({
    initialValues: {
      description: "",
      price: ""
    },
    onSubmit: function onSubmit(values) {
      setInProgress(true);
      dispatch({
        type: _ChatActions.MAKE_PROPOSITION_FROM_CHAT,
        data: _objectSpread(_objectSpread({}, values), {}, {
          product: product.id,
          user_id: user.id,
          emitted_by_buyer: _index.EMITTED_BY_BUYER
        }),
        message: values.description === "" ? [{
          body: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
            id: "Je vous propose ".concat(values.price, " \u20AC"),
            defaultMessage: "Je vous propose ".concat(values.price, " \u20AC")
          }),
          user: user,
          attachments: []
        }] : [{
          id: lastMessage !== null ? (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.id) + 1 : 0,
          body: "".concat(values === null || values === void 0 ? void 0 : values.description),
          user: user,
          attachments: []
        }, {
          id: lastMessage !== null ? (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.id) + 2 : 1,
          body: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
            id: "Je vous propose ".concat(values.price, " \u20AC"),
            defaultMessage: "Je vous propose ".concat(values.price, " \u20AC")
          }),
          user: user,
          attachments: []
        }],
        onSuccess: function onSuccess() {
          handleClose();
        }
      });
      setInProgress(false);
    }
  });
  var handleClose = function handleClose() {
    setOfferPopUpOpen(false);
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.buttonsHeaderWrapper
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "button",
    onClick: function onClick() {
      return setOfferPopUpOpen(true);
    },
    className: classes.offerButton
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Faire une offre",
    defaultMessage: "Faire une offre"
  }))), /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    open: offerPopUpOpen,
    onClose: handleClose,
    "aria-labelledby": "form-dialog-title"
  }, /*#__PURE__*/_react.default.createElement(_DialogTitle.default, {
    id: "form-dialog-title"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Proposition",
    defaultMessage: "Proposition"
  })), /*#__PURE__*/_react.default.createElement(_DialogContent.default, null, /*#__PURE__*/_react.default.createElement(_DialogContentText.default, null, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Lorem ipsum proposition of price about a product",
    defaultMessage: "Lorem ipsum proposition of price about a product"
  })), /*#__PURE__*/_react.default.createElement(_formik.FormikContext.Provider, {
    value: formik
  }, /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: formik.handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    name: "price",
    label: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "Price",
      defaultMessage: "Price"
    }),
    required: true,
    disabled: inProgress,
    fullWidth: true,
    validate: (0, _formValidators.validators)([(0, _formValidators.required)(), (0, _formValidators.number)()])
  }), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    name: "description",
    label: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "Description",
      defaultMessage: "Description"
    }),
    type: "text",
    disabled: inProgress,
    fullWidth: true
  }), /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: handleClose,
    color: "primary"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Cancel",
    defaultMessage: "Cancel"
  })), /*#__PURE__*/_react.default.createElement(_core.Button, {
    color: "primary",
    disabled: inProgress,
    type: "submit"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Submit",
    defaultMessage: "Submit"
  }))))))));
};
var _default = MakePropositionDialog;
exports.default = _default;